<template>
  <div id="idlePublish">
    <div class="box">
      <el-form label-position="right" label-width="120px">
        <el-form-item label="商品标题：">
          <el-input v-model="form.title" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="商品规格：">
          <el-input v-model="form.specification" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="商品分类：">
          <el-select v-model="form.category" placeholder="请选择">
            <el-option v-for="item in options" :key="item.index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="购买日期：">
          <div class="block">
            <el-date-picker
              style="width:300px"
              v-model="value3"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="timestamp"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="保质期：">
          <div class="block">
            <el-date-picker
              style="width:300px"
              v-model="stale_date"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="timestamp"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="购买来源：">
          <el-input v-model="buy_source" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="品牌：">
          <el-input v-model="form.brand" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="货号：">
          <el-input v-model="item_no" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="数量：">
          <el-input-number v-model="form.number" :min="1" :max="99" size="small"></el-input-number>
        </el-form-item>
        <el-form-item label="描述：">
          <el-input v-model="form.info" type="textarea" :rows="5"></el-input>
        </el-form-item>
        <el-form-item label="售价：">
          <el-input v-model="form.selling_price" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="说明书：">
          <el-upload
            style="margin-right:10px"
            class="upload-demo"
            action
            :auto-upload="false"
            :limit="1"
            :on-change="handleRemove"
          >
            <el-button size="small" plain>选择说明书</el-button>
          </el-upload>
          <div class="lv3Text">文件必须为word文档或者PDF格式</div>
        </el-form-item>
        <el-form-item label="上传商品图片：">
          <el-upload
            action
            list-type="picture-card"
            :auto-upload="false"
            :on-change="openImage"
            :limit="3"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="费用介绍：">
          <span>宝枫林平台将收取10%的手续费</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="width:150px;" @click="submit">确认发布</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,

      value3: "",
      stale_date: "",
      buy_source: "",
      item_no: "",
      doc: Object,
      imageall: [],
      form: {
        number: 1
      },
      srcs: [],
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      options: [
        "抗体",
        "种质资源",
        "文具类",
        "试剂",
        "办公设备",
        "耗材",
        "仪器",
        "书籍",
        "实验室办公/日品"
      ],
      loading: false,
      formData: new FormData()
    };
  },
  watch: {},
  created() {
    this.$store.state.user_location = "闲置交换";
    this.$store.state.user_location2 = "发布闲置";
    this.$store.state.leftMenuIndex = 14;
    this.initData();
  },
  methods: {
    openImage(file, fileList) {
      this.imageall = fileList;
    },
    handleRemove(file, fileList) {
      this.doc = file.raw;
    },
    del(i) {
      this.$set(this.srcs, i, null);
      var num = i + 1;
      this.formData.delete("image" + num);
    },
    inputAction(e, i) {
      var type = e.target.files[0].type;
      if (type == "image/png" || type == "image/jpg" || type == "image/jpeg") {
        var that = this;
        var imgFile = e.target.files[0];
        var reader = new FileReader();
        reader.readAsDataURL(imgFile);
        reader.onload = function(e) {
          var result = e.target.result;
          that.$set(that.srcs, i, result);
        };
        var num = i + 1;
        this.formData.append("image" + num, imgFile);
      }
    },
    openChooser() {
      if (!this.srcs[0]) {
        this.$refs.input0.click();
        return;
      } else if (!this.srcs[1]) {
        this.$refs.input1.click();
        return;
      } else if (!this.srcs[2]) {
        this.$refs.input2.click();
        return;
      }
    },
    submit() {
      this.loading = true;
      this.formData.append("mobile", this.mobile);
      this.formData.append("token", this.token);
      this.formData.append("title", this.form.title);
      this.formData.append("specification", this.form.specification);
      this.formData.append("category", this.form.category);
      this.formData.append("brand", this.form.brand);
      this.formData.append("buy_time", this.value3 / 1000);
      this.formData.append("buy_source", this.buy_source);
      this.formData.append("item_no", this.item_no);
      this.formData.append("doc", this.doc);
      this.formData.append("stale_date", this.stale_date / 1000);
      this.formData.append("number", this.form.number);
      this.formData.append("selling_price", this.form.selling_price);
      this.formData.append("info", this.form.info);
      if (this.imageall[0]) {
        this.formData.append("image1", this.imageall[0].raw);
      }
      if (this.imageall[1]) {
        this.formData.append("image2", this.imageall[1].raw);
      }
      if (this.imageall[2]) {
        this.formData.append("image3", this.imageall[2].raw);
      }
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      var that = this;
      this.axios
        .post(
          this.serve + "/exchange/create_exchange",
          this.formData,
          config
        )
        .then(res=> {
          if (res.data.status == "success") {
            that.$router.push("/user/idle/after");
          }else if(res.data.status == "error"){
            this.$message({
              type : 'error',
              message : res.data.msg,
              // offset : 160
            })
          }
        });
    },
    initData() {}
  }
};
</script>
<style lang="scss">
#idlePublish {
  padding-bottom: 50px;
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 50px 250px;
    .pic {
      width: 150px;
      height: 150px;
    }
  }
  .fa-times {
    position: relative;
    left: -55px;
    top: -140px;
    float: right;
    cursor: pointer;
  }
  .fa-times:hover {
    color: #e2211c;
  }
}
</style>